var overrides = {
    MuiChip: {
        styleOverrides: {
            deleteIcon: {
                "@media print": {
                    display: "none"
                }
            }
        }
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                "@media print": {
                    boxShadow: "none"
                }
            }
        }
    },
    MuiButton: {
        styleOverrides: {
            root: {
                "@media print": {
                    display: "none"
                }
            }
        }
    },
    MuiIconButton: {
        styleOverrides: {
            root: {
                "@media print": {
                    display: "none"
                }
            }
        }
    },
    MuiDialog: {
        defaultProps: {
            fullWidth: true,
            maxWidth: "lg"
        }
    },
    MuiDialogContent: {
        styleOverrides: {
            root: function(param) {
                var theme = param.theme;
                return {
                    padding: "".concat(theme.spacing(2.5), " ").concat(theme.spacing(5))
                };
            }
        }
    },
    MuiTextField: {
        defaultProps: {
            variant: "filled"
        }
    },
    MuiSelect: {
        defaultProps: {
            variant: "filled"
        }
    },
    MuiFormControl: {
        defaultProps: {
            variant: "filled"
        }
    },
    MuiInputLabel: {
        defaultProps: {
            variant: "filled"
        }
    },
    MuiFormHelperText: {
        defaultProps: {
            variant: "filled"
        }
    },
    MuiTooltip: {
        styleOverrides: {
            tooltip: {
                fontSize: "0.8rem"
            }
        }
    }
};
export default overrides;
